import React, { useState } from 'react';
import { Button, Dropdown, Modal } from 'antd';
import { DownOutlined } from '@ant-design/icons';

const PostActionMenus = ({ post, owner, canManage, canEnterGroup, activityItems = [], visitorActions, postBusy, chatBusy, onManage, onGroup, onEdit, onClose, onDelete, onReopen, onExtend }) => {
  const [confirmation, setConfirmation] = useState(null);
  const deleting = confirmation === 'delete';
  const items = [
    ...(canManage ? [{ key: 'applications', label: '管理招募申请', onClick: onManage }] : []),
    ...(canEnterGroup ? [{ key: 'group', label: '进入帖子群聊', disabled: chatBusy, onClick: onGroup }] : []),
    ...activityItems,
  ];
  return <>
    {(items.length > 0 || owner || visitorActions) && <div className="post-detail-management-actions" aria-label="更多操作">
      {items.length > 0 && <Dropdown menu={{ items }} trigger={['click']} placement="bottomRight" disabled={postBusy}>
        <Button disabled={postBusy} loading={chatBusy}>活动管理<DownOutlined aria-hidden="true" /></Button>
      </Dropdown>}
      {owner && <Dropdown trigger={['click']} placement="bottomRight" disabled={postBusy} menu={{ items: [
        { key: 'edit', label: '编辑帖子', onClick: onEdit },
        ...(!post.completed_at && ['active', 'expired'].includes(post.status) ? [{ key: 'extend', label: '延长有效期', onClick: onExtend }] : []),
        { key: 'close', label: '关闭帖子', disabled: post.status !== 'active', onClick: () => setConfirmation('close') },
        ...(!post.completed_at && (post.status !== 'active' || !post.is_recruiting || Date.parse(post.expire_time) <= Date.now()) ? [{ key: 'reopen', label: '重新开放招募', onClick: onReopen }] : []),
        { type: 'divider' },
        { key: 'delete', label: '删除帖子', danger: true, onClick: () => setConfirmation('delete') },
      ] }}>
        <Button className="post-detail-post-menu" disabled={postBusy}>帖子管理<DownOutlined aria-hidden="true" /></Button>
      </Dropdown>}
      {visitorActions}
    </div>}
    <Modal title={deleting ? '确认删除帖子' : '确认关闭帖子'} open={Boolean(confirmation)} confirmLoading={postBusy}
      okText={deleting ? '确认删除帖子' : '确认关闭帖子'} cancelText="取消" okButtonProps={{ danger: deleting }}
      closable={!postBusy} mask={{ closable: !postBusy }} keyboard={!postBusy} cancelButtonProps={{ disabled: postBusy }}
      onCancel={() => !postBusy && setConfirmation(null)} onOk={async () => {
        if (postBusy) return;
        const success = await (deleting ? onDelete() : onClose());
        if (success !== false) setConfirmation(null);
      }}>
      <p>{deleting
        ? post.is_recruiting ? '评论、申请和帖子群聊也将删除，无法恢复。' : '相关数据也将删除，无法恢复。'
        : '关闭后停止招募，已有申请和群成员保留。符合条件时可重新开放招募。'}</p>
    </Modal>
  </>;
};

export default PostActionMenus;
